import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Signin from "../pages/Authentication";
import Dashboard from "../pages/Dashboard";
import { ROUTES } from "./constant";
import PublicRoute from "./Public.route";
import PrivateRoute from "./Private.route";
import Meeting from "../pages/Meeting";
import MeetingLinkGenerator from "../pages/Link";
import User from "../pages/User";

const Approuters = () => {
  const publicRoutes = [
    {
      key: 1,
      path: ROUTES.INDEX,
      component: Signin,
      restricted: true,
    },
    {
      key: 2,
      path: ROUTES.MEETING,
      component: Meeting,
      restricted: false,
    },
    
  ];
  const privateRoute = [
    {
      key: 1,
      path: ROUTES.DASHBOARD,
      component: Dashboard,
      restricted: true,
    },
    {
      key: 2,
      path: ROUTES.MEETING_LINK,
      component: MeetingLinkGenerator,
      restricted: true,
    },
    {
      key: 3,
      path: ROUTES.USER_LIST,
      component: User,
      restricted: true,
    },
  ];
  return (
    <Router>
      <Routes>
        {publicRoutes.map((i) => (
          <Route
            path={i?.path}
            element={
              <PublicRoute
                restricted={i?.restricted}
                key={i?.key}
                component={i?.component}
              />
            }
          />
        ))}

        {privateRoute.map((i) => (
          <Route
            path={i?.path}
            element={<PrivateRoute key={i?.key} component={i?.component} />}
          />
        ))}
      </Routes>
    </Router>
  );
};

export default Approuters;
